import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { ClientState } from "~/src/api/types";
import { jaktdataApi } from "~/src/appGlobals";
import { AlertVariant } from "~/src/components/Alerts/AlertDefault";
import UIContext from "~/src/contexts/UIContext/UIProvider";

export const useClientState = (): ClientState => {
  const ui = useContext(UIContext);

  const clientState = useQuery({
    queryKey: ["clientState"],
    queryFn: jaktdataApi.getClientState,
    networkMode: "always",
    staleTime: 5000,
    retry: 0,
  });

  useEffect(() => {
    const checkIfOnline = async () => {
      await clientState.refetch();
    };

    if (clientState.error) {
      ui.showSnackbar({
        message: clientState.error.message,
        severity: AlertVariant.Error,
      });
    }

    window.addEventListener("online", checkIfOnline);
    window.addEventListener("offline", checkIfOnline);
    window.addEventListener("focus", checkIfOnline);

    return () => {
      window.removeEventListener("online", checkIfOnline);
      window.removeEventListener("offline", checkIfOnline);
      window.removeEventListener("focus", checkIfOnline);
    };
  }, [clientState.error]);

  return clientState.data || "Loading";
};
